import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { Component } from 'react';
import Text from '../Text';
import StackView from '../StackView';

function Tab(_ref) {
  var isSelected = _ref.isSelected,
      selectedColor = _ref.selectedColor,
      onSelect = _ref.onSelect,
      restProps = _objectWithoutPropertiesLoose(_ref, ["isSelected", "selectedColor", "onSelect"]);

  return /*#__PURE__*/React.createElement(Text, _extends({
    as: "button",
    tabIndex: isSelected ? -1 : undefined,
    position: "relative",
    fontSize: 4,
    fontWeight: isSelected ? 600 : undefined,
    padding: 1,
    borderBottomWidth: 2,
    borderBottomColor: isSelected ? selectedColor : 'separatorTertiary',
    textAlign: "center",
    userSelect: "none",
    cursor: isSelected ? undefined : 'pointer',
    hover: {
      borderBottomColor: isSelected ? undefined : 'separatorSecondary'
    },
    onClick: isSelected ? undefined : onSelect
  }, restProps));
}

var SegmentedTabs = /*#__PURE__*/function (_Component) {
  _inheritsLoose(SegmentedTabs, _Component);

  function SegmentedTabs(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "setIndex", function (index) {
      if (_this.props.activeTab === undefined) {
        _this.setState({
          activeIndex: index
        });
      }

      if (_this.props.onChange) {
        _this.props.onChange(_this.props.tabs[index]);
      }
    });

    _this.state = {
      activeIndex: _this.getActiveIndex(props)
    };
    return _this;
  }

  var _proto = SegmentedTabs.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(lastProps) {
    if (this.props.activeTab) {
      var lastActiveIndex = this.getActiveIndex(lastProps);
      var nextActiveIndex = this.getActiveIndex(this.props);

      if (lastActiveIndex !== nextActiveIndex || this.state.activeIndex !== nextActiveIndex) {
        this.setState({
          activeIndex: nextActiveIndex
        });
      }
    }
  };

  _proto.getActiveIndex = function getActiveIndex(_ref2) {
    var activeTab = _ref2.activeTab,
        tabs = _ref2.tabs;
    var index;

    if (typeof activeTab === 'function') {
      index = tabs.reduce(function (searchIndex, tab, index) {
        if (activeTab(tab, index)) {
          searchIndex = index;
        }

        return searchIndex;
      }, null);
    } else {
      index = activeTab === undefined ? 0 : tabs.indexOf(activeTab);
    }

    return index;
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        activeTab = _this$props.activeTab,
        color = _this$props.color,
        getTabLabel = _this$props.getTabLabel,
        onChange = _this$props.onChange,
        tabs = _this$props.tabs,
        tabProps = _this$props.tabProps,
        restProps = _objectWithoutPropertiesLoose(_this$props, ["activeTab", "color", "getTabLabel", "onChange", "tabs", "tabProps"]);

    var activeIndex = this.state.activeIndex;
    return /*#__PURE__*/React.createElement(StackView, _extends({
      role: "group",
      axis: "horizontal",
      distribution: "fill",
      position: "relative"
    }, restProps), tabs.map(function (tab, index) {
      return /*#__PURE__*/React.createElement(Tab, _extends({
        key: index,
        index: index,
        isSelected: index === activeIndex,
        selectedColor: color,
        onSelect: function onSelect() {
          return _this2.setIndex(index);
        }
      }, tabProps), getTabLabel(tab));
    }));
  };

  return SegmentedTabs;
}(Component);

_defineProperty(SegmentedTabs, "defaultProps", {
  color: 'primary',
  getTabLabel: function getTabLabel(tab) {
    return tab;
  }
});

export default SegmentedTabs;